import React from 'react'
import MyUITypes from './MyUITypes';
class MyUI extends React.Component {    
  render(){
    const {type} = this.props;
    // console.warn("render MyUI:",this.props,type,MyUITypes.Types);
    if(type && MyUITypes.Types[type]){
      return MyUITypes.Types[type](this.props);
    }
    console.warn("MyUI no type",this.props);
    return (
      <div></div>
    )
  } 
}

export default MyUI